(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["buscador-overlay"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class BsqBuscador {
      constructor(seccion) {
        this.seccion = seccion;
        this.input = seccion.querySelector('[data-bsq-input]');
        this.cerrarBtn = seccion.querySelector('[data-bsq-cerrar]');
        this.pill = seccion.querySelector('[data-bsq-pill]');
        this.init();
      }

      init() {
        document.addEventListener('click', (e) => {
          const trigger = e.target.closest('.hfh-icono[aria-label="Buscar"]');
          if (trigger) {
            e.preventDefault();
            this.toggle();
            return;
          }
          if (this.seccion.classList.contains('bsq-abierto') && this.pill && !this.pill.contains(e.target)) {
            this.cerrar();
          }
        });

        if (this.cerrarBtn) {
          this.cerrarBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.cerrar();
          });
        }

        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.seccion.classList.contains('bsq-abierto')) {
            this.cerrar();
          }
        });
      }

      toggle() {
        if (this.seccion.classList.contains('bsq-abierto')) {
          this.cerrar();
        } else {
          this.abrir();
        }
      }

      abrir() {
        this.seccion.classList.add('bsq-abierto');
        this.seccion.setAttribute('aria-hidden', 'false');
        setTimeout(() => {
          if (this.input) this.input.focus();
        }, 200);
      }

      cerrar() {
        this.seccion.classList.remove('bsq-abierto');
        this.seccion.setAttribute('aria-hidden', 'true');
        if (this.input) this.input.value = '';
      }
    }

    function inicializar() {
      document.querySelectorAll('[data-bsq-seccion]').forEach((seccion) => {
        if (!seccion.dataset.bsqInit) {
          new BsqBuscador(seccion);
          seccion.dataset.bsqInit = 'true';
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', inicializar);
    } else {
      inicializar();
    }

    document.addEventListener('shopify:section:load', inicializar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrito-drawer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class CrrCarrito {
      constructor(seccion) {
        this.seccion = seccion;
        this.drawer = seccion.querySelector('[data-crr-drawer]');
        this.overlay = seccion.querySelector('[data-crr-overlay]');
        this.cerrarBtn = seccion.querySelector('[data-crr-cerrar]');
        this.contenido = seccion.querySelector('[data-crr-contenido]');
        this.pie = seccion.querySelector('[data-crr-pie]');
        this.totalEl = seccion.querySelector('[data-crr-total]');
        this.umbral = parseFloat(seccion.dataset.crrUmbral) || 0;
        this.mostrarProgreso = seccion.dataset.crrMostrarProgreso === 'true';
        this.moneyFormat = (window.Shopify && window.Shopify.currency) ? window.Shopify.currency.active : 'EUR';
        this.cargando = false;
        this.init();
      }

      init() {
        document.addEventListener('click', (e) => {
          const trigger = e.target.closest('.hfh-icono[aria-label="Carrito"]');
          if (trigger) {
            e.preventDefault();
            this.abrir();
          }
        });

        if (this.overlay) {
          this.overlay.addEventListener('click', () => this.cerrar());
        }
        if (this.cerrarBtn) {
          this.cerrarBtn.addEventListener('click', () => this.cerrar());
        }

        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.seccion.classList.contains('crr-abierto')) {
            this.cerrar();
          }
        });

        document.addEventListener('cart:updated', () => {
          this.cargarCarrito(true);
        });

        document.addEventListener('cart:refresh', () => {
          this.cargarCarrito(false);
        });

        this.interceptarFormulariosProducto();
        this.interceptarFetch();
        this.cargarCarrito(false);
      }

      interceptarFormulariosProducto() {
        document.addEventListener('click', (e) => {
          const submitBtn = e.target.closest('button[type="submit"][name="add"], button.product-form__submit');
          if (!submitBtn) return;
          const form = submitBtn.closest('form[action*="/cart/add"]');
          if (!form) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          this.anadirAlCarrito(form);
        }, true);

        document.addEventListener('submit', (e) => {
          const form = e.target;
          if (!form.matches('form[action*="/cart/add"]')) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          this.anadirAlCarrito(form);
        }, true);

        document.addEventListener('click', (e) => {
          const link = e.target.closest('a[href="/cart"], a[href$="/cart"]');
          if (link && !link.closest('.crr-drawer') && !link.closest('.hfh-icono')) {
            e.preventDefault();
            this.abrir();
          }
        });
      }

      interceptarFetch() {
        const self = this;
        if (window.__crrFetchPatched) return;
        window.__crrFetchPatched = true;
        const origFetch = window.fetch;
        window.fetch = function (...args) {
          const url = args[0];
          const urlString = typeof url === 'string' ? url : (url && url.url ? url.url : '');
          const esCartAdd = urlString.includes('/cart/add');
          const promise = origFetch.apply(this, args);
          if (esCartAdd) {
            promise.then((r) => {
              if (r && r.ok) {
                setTimeout(() => {
                  self.cargarCarrito(true);
                  document.dispatchEvent(new CustomEvent('cart:updated'));
                }, 150);
              }
            }).catch(() => {});
          }
          return promise;
        };
      }

      anadirAlCarrito(form) {
        const submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;

        const formData = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then((r) => {
            if (!r.ok) throw new Error('Error al añadir');
            return r.json();
          })
          .then(() => {
            this.cargarCarrito(true);
            document.dispatchEvent(new CustomEvent('cart:updated'));
          })
          .catch((err) => {
            console.error('Error añadiendo al carrito:', err);
          })
          .finally(() => {
            if (submitBtn) submitBtn.disabled = false;
          });
      }

      cargarCarrito(abrirDespues) {
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .then((cart) => {
            this.renderizar(cart);
            if (abrirDespues) this.abrir();
          })
          .catch(() => {});
      }

      renderizar(cart) {
        if (!this.contenido) return;

        if (cart.item_count === 0) {
          this.contenido.innerHTML = '<div class="crr-vacio"><p class="crr-vacio-mensaje">Tu carrito está vacío</p></div>';
          if (this.pie) this.pie.hidden = true;
          return;
        }

        let html = '';

        if (this.mostrarProgreso && this.umbral > 0) {
          const totalNum = cart.total_price / 100;
          const restante = Math.max(0, this.umbral - totalNum);
          const porcentaje = Math.min(100, (totalNum / this.umbral) * 100);
          const mensaje = restante > 0
            ? `Te faltan ${this.formatearPrecio(restante * 100)} para envío gratuito`
            : 'Has conseguido envío gratuito';
          html += '<div class="crr-progreso">';
          html += '<span class="crr-progreso-mensaje">' + mensaje + '</span>';
          html += '<div class="crr-progreso-barra"><div class="crr-progreso-relleno" style="width: ' + porcentaje + '%"></div></div>';
          html += '</div>';
        }

        html += '<ul class="crr-items">';
        cart.items.forEach((item) => {
          html += '<li class="crr-item" data-crr-key="' + item.key + '">';
          html += '<a href="' + item.url + '" class="crr-item-imagen">';
          if (item.image) {
            html += '<img src="' + item.image.replace(/(\.[^.]+)$/, '_200x$1') + '" alt="' + this.escapar(item.product_title) + '" loading="lazy">';
          }
          html += '</a>';
          html += '<div class="crr-item-info">';
          html += '<h3 class="crr-item-nombre"><a href="' + item.url + '">' + this.escapar(item.product_title) + '</a></h3>';
          html += '<span class="crr-item-precio">' + this.formatearPrecio(item.final_price) + '</span>';
          if (item.variant_title && item.variant_title !== 'Default Title') {
            html += '<span class="crr-item-variante">' + this.escapar(item.variant_title) + '</span>';
          }
          html += '<div class="crr-item-acciones">';
          html += '<div class="crr-cantidad">';
          html += '<button type="button" class="crr-cantidad-btn" data-crr-decrementar aria-label="Disminuir cantidad">';
          html += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line></svg>';
          html += '</button>';
          html += '<span class="crr-cantidad-valor">' + item.quantity + '</span>';
          html += '<button type="button" class="crr-cantidad-btn" data-crr-incrementar aria-label="Aumentar cantidad">';
          html += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>';
          html += '</button>';
          html += '</div>';
          html += '<button type="button" class="crr-eliminar" data-crr-eliminar>Eliminar</button>';
          html += '</div>';
          html += '</div>';
          html += '</li>';
        });
        html += '</ul>';

        this.contenido.innerHTML = html;

        if (this.totalEl) this.totalEl.textContent = this.formatearPrecio(cart.total_price);
        if (this.pie) this.pie.hidden = false;

        this.vincularEventosItems();
      }

      vincularEventosItems() {
        this.contenido.querySelectorAll('.crr-item').forEach((item) => {
          const key = item.dataset.crrKey;
          const inc = item.querySelector('[data-crr-incrementar]');
          const dec = item.querySelector('[data-crr-decrementar]');
          const del = item.querySelector('[data-crr-eliminar]');
          const cantidadValor = item.querySelector('.crr-cantidad-valor');

          if (inc) {
            inc.addEventListener('click', () => {
              const nueva = parseInt(cantidadValor.textContent, 10) + 1;
              this.actualizarCantidad(key, nueva);
            });
          }
          if (dec) {
            dec.addEventListener('click', () => {
              const nueva = Math.max(0, parseInt(cantidadValor.textContent, 10) - 1);
              this.actualizarCantidad(key, nueva);
            });
          }
          if (del) {
            del.addEventListener('click', () => {
              this.actualizarCantidad(key, 0);
            });
          }
        });
      }

      actualizarCantidad(key, cantidad) {
        if (this.cargando) return;
        this.cargando = true;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: cantidad })
        })
          .then((r) => r.json())
          .then((cart) => {
            this.renderizar(cart);
            document.dispatchEvent(new CustomEvent('cart:updated'));
          })
          .catch(() => {})
          .finally(() => {
            this.cargando = false;
          });
      }

      formatearPrecio(centavos) {
        const valor = centavos / 100;
        try {
          return new Intl.NumberFormat('es-ES', { style: 'currency', currency: this.moneyFormat }).format(valor);
        } catch (e) {
          return '€' + valor.toFixed(2);
        }
      }

      escapar(str) {
        const div = document.createElement('div');
        div.textContent = str;
        return div.innerHTML;
      }

      abrir() {
        this.seccion.classList.add('crr-abierto');
        this.seccion.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }

      cerrar() {
        this.seccion.classList.remove('crr-abierto');
        this.seccion.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    }

    function inicializar() {
      document.querySelectorAll('[data-crr-seccion]').forEach((seccion) => {
        if (!seccion.dataset.crrInit) {
          new CrrCarrito(seccion);
          seccion.dataset.crrInit = 'true';
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', inicializar);
    } else {
      inicializar();
    }

    document.addEventListener('shopify:section:load', inicializar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["galeria-deslizante"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function arrancarGdz(seccion) {
      if (seccion.dataset.gdzReady) return;
      seccion.dataset.gdzReady = '1';
      var marquesina = seccion.querySelector('.gdz-marquesina');
      var pista = seccion.querySelector('.gdz-pista');
      if (!marquesina || !pista) return;
      var velocidad = parseFloat(seccion.getAttribute('data-gdz-velocidad'));
      if (!velocidad || isNaN(velocidad)) velocidad = 40;
      var offset = 0;
      var halfWidth = 0;
      var lastTime = 0;
      var arrastrando = false;
      var startX = 0;
      var startOffset = 0;
      var pausaInteraccion = false;
      var timerReanudar = null;
      function medir() {
        var nuevoHalf = pista.scrollWidth / 2;
        if (nuevoHalf !== halfWidth) halfWidth = nuevoHalf;
      }
      function pintar() {
        pista.style.transform = 'translate3d(' + (-offset) + 'px, 0, 0)';
      }
      function wrapSuave() {
        if (halfWidth <= 0) return;
        while (offset >= halfWidth) {
          offset -= halfWidth;
          startOffset -= halfWidth;
        }
        while (offset < 0) {
          offset += halfWidth;
          startOffset += halfWidth;
        }
      }
      function programarReanudar() {
        if (timerReanudar) clearTimeout(timerReanudar);
        pausaInteraccion = true;
        timerReanudar = setTimeout(function() {
          pausaInteraccion = false;
          lastTime = 0;
        }, 1500);
      }
      function bucle(t) {
        if (!lastTime) lastTime = t;
        var dt = (t - lastTime) / 1000;
        if (dt > 0.1) dt = 0.016;
        lastTime = t;
        if (halfWidth <= 0) medir();
        if (!arrastrando && !pausaInteraccion && halfWidth > 0) {
          offset += velocidad * dt;
          wrapSuave();
          pintar();
        }
        requestAnimationFrame(bucle);
      }
      marquesina.addEventListener('pointerdown', function(e) {
        arrastrando = true;
        marquesina.classList.add('gdz-arrastrando');
        startX = e.clientX;
        startOffset = offset;
        if (timerReanudar) clearTimeout(timerReanudar);
        pausaInteraccion = true;
        try { marquesina.setPointerCapture(e.pointerId); } catch (err) {}
      });
      marquesina.addEventListener('pointermove', function(e) {
        if (!arrastrando) return;
        var delta = e.clientX - startX;
        offset = startOffset - delta;
        wrapSuave();
        pintar();
      });
      marquesina.addEventListener('pointerup', function(e) {
        if (!arrastrando) return;
        arrastrando = false;
        marquesina.classList.remove('gdz-arrastrando');
        try { marquesina.releasePointerCapture(e.pointerId); } catch (err) {}
        programarReanudar();
      });
      marquesina.addEventListener('pointercancel', function() {
        arrastrando = false;
        marquesina.classList.remove('gdz-arrastrando');
        programarReanudar();
      });
      marquesina.addEventListener('wheel', function(e) {
        if (Math.abs(e.deltaX) > 0.5) {
          e.preventDefault();
        }
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY) && Math.abs(e.deltaX) > 1) {
          offset += e.deltaX;
          wrapSuave();
          pintar();
          programarReanudar();
        }
      }, { passive: false });
      window.addEventListener('resize', medir);
      medir();
      var intentos = 0;
      var intervaloMedir = setInterval(function() {
        intentos++;
        medir();
        if (halfWidth > 0 || intentos > 20) clearInterval(intervaloMedir);
      }, 250);
      var imgs = pista.querySelectorAll('img');
      imgs.forEach(function(img) {
        if (img.complete) return;
        img.addEventListener('load', medir);
        img.addEventListener('error', medir);
      });
      requestAnimationFrame(bucle);
    }
    function iniciarTodas() {
      var secciones = document.querySelectorAll('.gdz-seccion');
      for (var i = 0; i < secciones.length; i++) arrancarGdz(secciones[i]);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciarTodas);
    } else {
      iniciarTodas();
    }
    document.addEventListener('shopify:section:load', iniciarTodas);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["galeria-videos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function inicializar(seccion) {
      if (!seccion || seccion.dataset.gvdInit) return;
      seccion.dataset.gvdInit = 'true';
      var videos = seccion.querySelectorAll('[data-gvd-video]');
      if (!videos.length) return;
      if (!('IntersectionObserver' in window)) {
        videos.forEach(function (v) {
          var p = v.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        });
        return;
      }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
            var p = video.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          } else {
            if (!video.paused) video.pause();
          }
        });
      }, { threshold: [0, 0.35, 0.7] });
      videos.forEach(function (v) { observer.observe(v); });
    }
    function init() {
      document.querySelectorAll('.gvd-seccion').forEach(inicializar);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-verano"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class HfhSeccion {
      constructor(seccion) {
        this.seccion = seccion;
        this.toggle = seccion.querySelector('[data-hfh-toggle]');
        this.cerrar = seccion.querySelector('[data-hfh-cerrar]');
        this.menuMobile = seccion.querySelector('[data-hfh-menu-mobile]');
        this.mobileToggles = seccion.querySelectorAll('[data-hfh-mobile-toggle]');
        this.cartCount = seccion.querySelector('[data-hfh-cart-count]');
        this.init();
      }

      init() {
        if (this.toggle && this.menuMobile) {
          this.toggle.addEventListener('click', () => this.abrir());
        }
        if (this.cerrar && this.menuMobile) {
          this.cerrar.addEventListener('click', () => this.cerrarMenu());
        }
        this.mobileToggles.forEach((boton) => {
          boton.addEventListener('click', () => this.toggleSubmenu(boton));
        });
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.menuMobile && this.menuMobile.classList.contains('hfh-activo')) {
            this.cerrarMenu();
          }
        });
        this.escucharCarrito();
      }

      abrir() {
        if (!this.menuMobile) return;
        this.menuMobile.classList.add('hfh-activo');
        this.menuMobile.setAttribute('aria-hidden', 'false');
        this.toggle.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      }

      cerrarMenu() {
        if (!this.menuMobile) return;
        this.menuMobile.classList.remove('hfh-activo');
        this.menuMobile.setAttribute('aria-hidden', 'true');
        if (this.toggle) this.toggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }

      toggleSubmenu(boton) {
        const submenu = boton.nextElementSibling;
        const expandido = boton.getAttribute('aria-expanded') === 'true';
        boton.setAttribute('aria-expanded', expandido ? 'false' : 'true');
        if (submenu) submenu.classList.toggle('hfh-activo');
      }

      escucharCarrito() {
        if (!this.cartCount) return;
        const actualizar = () => {
          fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then((r) => r.json())
            .then((data) => {
              const total = data.item_count || 0;
              this.cartCount.textContent = total;
              if (total > 0) {
                this.cartCount.removeAttribute('hidden');
              } else {
                this.cartCount.setAttribute('hidden', '');
              }
            })
            .catch(() => {});
        };
        document.addEventListener('cart:refresh', actualizar);
        document.addEventListener('cart:updated', actualizar);
      }
    }

    function inicializar() {
      document.querySelectorAll('.hfh-seccion').forEach((seccion) => {
        if (!seccion.dataset.hfhInit) {
          new HfhSeccion(seccion);
          seccion.dataset.hfhInit = 'true';
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', inicializar);
    } else {
      inicializar();
    }

    document.addEventListener('shopify:section:load', inicializar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mejoras-tarjetas"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const ESDESKTOP = () => window.matchMedia('(min-width: 750px)').matches;
    const cacheProductos = new Map();

    function obtenerImagenesProducto(url) {
      if (cacheProductos.has(url)) return Promise.resolve(cacheProductos.get(url));
      return fetch(url + '.js', { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((data) => {
          const imagenes = (data.images || []).slice(0, 6);
          cacheProductos.set(url, imagenes);
          return imagenes;
        })
        .catch(() => []);
    }

    class MtjTarjeta {
      constructor(card, hoverActivo, swipeActivo) {
        this.card = card;
        this.hoverActivo = hoverActivo;
        this.swipeActivo = swipeActivo;
        this.imagenes = [];
        this.indiceActual = 0;
        this.inicializado = false;
        this.init();
      }

      obtenerUrlProducto() {
        const link = this.card.querySelector('a[href*="/products/"]');
        if (!link) return null;
        const href = link.getAttribute('href');
        return href.split('?')[0].split('#')[0];
      }

      obtenerContenedorMedia() {
        return this.card.querySelector('.card__media .media, .card .media') || this.card.querySelector('.media');
      }

      init() {
        const url = this.obtenerUrlProducto();
        if (!url) return;

        const contenedorMedia = this.obtenerContenedorMedia();
        if (!contenedorMedia) return;

        const imagenPrincipal = contenedorMedia.querySelector('img');
        if (!imagenPrincipal) return;

        obtenerImagenesProducto(url).then((imagenes) => {
          if (!imagenes || imagenes.length < 2) return;
          this.imagenes = imagenes;
          this.contenedorMedia = contenedorMedia;
          this.imagenPrincipal = imagenPrincipal;
          this.setupSegunDispositivo();
        });

        window.addEventListener('resize', this.debounce(() => {
          if (!this.imagenes || this.imagenes.length < 2) return;
          this.limpiar();
          this.setupSegunDispositivo();
        }, 250));
      }

      setupSegunDispositivo() {
        if (ESDESKTOP() && this.hoverActivo) {
          this.setupHover();
        } else if (!ESDESKTOP() && this.swipeActivo) {
          this.setupSwipe();
        }
      }

      setupHover() {
        if (this.contenedorMedia.querySelector('.mtj-imagen-secundaria')) return;

        const img = document.createElement('img');
        const segundaUrl = this.imagenes[1].startsWith('//') ? 'https:' + this.imagenes[1] : this.imagenes[1];
        img.src = segundaUrl.replace(/(\.[^.]+)(\?.*)?$/, '_800x$1$2');
        img.alt = '';
        img.loading = 'lazy';
        img.classList.add('mtj-imagen-secundaria');

        this.contenedorMedia.style.position = 'relative';
        this.contenedorMedia.classList.add('mtj-card-wrapper');
        this.contenedorMedia.appendChild(img);

        requestAnimationFrame(() => {
          img.classList.add('mtj-activa');
        });
      }

      setupSwipe() {
        if (this.contenedorMedia.querySelector('.mtj-carrusel-mobile')) return;

        const carrusel = document.createElement('div');
        carrusel.className = 'mtj-carrusel-mobile';

        const track = document.createElement('div');
        track.className = 'mtj-carrusel-track';

        this.imagenes.forEach((src, idx) => {
          const slide = document.createElement('div');
          slide.className = 'mtj-carrusel-slide';
          const img = document.createElement('img');
          const fullUrl = src.startsWith('//') ? 'https:' + src : src;
          img.src = fullUrl.replace(/(\.[^.]+)(\?.*)?$/, '_800x$1$2');
          img.alt = '';
          img.loading = idx === 0 ? 'eager' : 'lazy';
          slide.appendChild(img);
          track.appendChild(slide);
        });

        const dots = document.createElement('div');
        dots.className = 'mtj-dots';
        this.imagenes.forEach((_, idx) => {
          const dot = document.createElement('span');
          dot.className = 'mtj-dot' + (idx === 0 ? ' mtj-dot-activo' : '');
          dots.appendChild(dot);
        });

        carrusel.appendChild(track);
        carrusel.appendChild(dots);

        const link = this.contenedorMedia.querySelector('a');
        if (link) {
          link.style.position = 'relative';
          link.style.display = 'block';
          link.appendChild(carrusel);
        } else {
          this.contenedorMedia.appendChild(carrusel);
        }

        this.track = track;
        this.dots = dots;
        this.carrusel = carrusel;
        this.indiceActual = 0;

        this.vincularSwipe(carrusel, track, link);
      }

      vincularSwipe(carrusel, track, link) {
        let startX = 0;
        let startY = 0;
        let currentX = 0;
        let arrastrando = false;
        let direccion = null;
        const umbral = 50;

        carrusel.addEventListener('touchstart', (e) => {
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          currentX = 0;
          arrastrando = true;
          direccion = null;
          track.classList.add('mtj-arrastrando');
        }, { passive: true });

        carrusel.addEventListener('touchmove', (e) => {
          if (!arrastrando) return;
          const deltaX = e.touches[0].clientX - startX;
          const deltaY = e.touches[0].clientY - startY;

          if (direccion === null) {
            if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 8) {
              direccion = 'horizontal';
            } else if (Math.abs(deltaY) > 8) {
              direccion = 'vertical';
            }
          }

          if (direccion === 'horizontal') {
            e.preventDefault();
            currentX = deltaX;
            const offset = -(this.indiceActual * 100) + (currentX / carrusel.offsetWidth) * 100;
            track.style.transform = 'translateX(' + offset + '%)';
          }
        }, { passive: false });

        carrusel.addEventListener('touchend', () => {
          if (!arrastrando) return;
          arrastrando = false;
          track.classList.remove('mtj-arrastrando');

          if (direccion === 'horizontal') {
            if (Math.abs(currentX) > umbral) {
              if (currentX < 0 && this.indiceActual < this.imagenes.length - 1) {
                this.indiceActual += 1;
              } else if (currentX > 0 && this.indiceActual > 0) {
                this.indiceActual -= 1;
              }
            }
            this.actualizarPosicion();
          }
        });

        if (link) {
          let movido = false;
          carrusel.addEventListener('touchstart', () => { movido = false; }, { passive: true });
          carrusel.addEventListener('touchmove', () => {
            if (direccion === 'horizontal') movido = true;
          }, { passive: true });
          link.addEventListener('click', (e) => {
            if (movido) {
              e.preventDefault();
              e.stopPropagation();
              movido = false;
            }
          });
        }
      }

      actualizarPosicion() {
        if (!this.track) return;
        this.track.style.transform = 'translateX(-' + (this.indiceActual * 100) + '%)';
        if (this.dots) {
          this.dots.querySelectorAll('.mtj-dot').forEach((dot, idx) => {
            dot.classList.toggle('mtj-dot-activo', idx === this.indiceActual);
          });
        }
      }

      limpiar() {
        const secundaria = this.contenedorMedia.querySelector('.mtj-imagen-secundaria');
        if (secundaria) secundaria.remove();
        const carrusel = this.contenedorMedia.querySelector('.mtj-carrusel-mobile');
        if (carrusel) carrusel.remove();
        this.contenedorMedia.classList.remove('mtj-card-wrapper');
      }

      debounce(fn, ms) {
        let t;
        return function (...args) {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, args), ms);
        };
      }
    }

    function inicializar() {
      const seccion = document.querySelector('[data-mtj-seccion]');
      if (!seccion) return;

      const hoverActivo = seccion.dataset.mtjHover === 'true';
      const swipeActivo = seccion.dataset.mtjSwipe === 'true';

      const tarjetas = document.querySelectorAll('.card-wrapper, .grid__item .card-wrapper, product-card');
      tarjetas.forEach((card) => {
        if (card.dataset.mtjInit) return;
        card.dataset.mtjInit = 'true';
        new MtjTarjeta(card, hoverActivo, swipeActivo);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', inicializar);
    } else {
      inicializar();
    }

    document.addEventListener('shopify:section:load', inicializar);
    document.addEventListener('shopify:section:reorder', inicializar);

    const observer = new MutationObserver((mutations) => {
      let nuevas = false;
      mutations.forEach((m) => {
        m.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.matches && (node.matches('.card-wrapper') || node.querySelector('.card-wrapper'))) {
            nuevas = true;
          }
        });
      });
      if (nuevas) inicializar();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-info"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function inicializar() {
      var seccion = document.querySelector('[data-nws-overlay]');
      if (!seccion || seccion.dataset.nwsInit) return;
      seccion.dataset.nwsInit = 'true';

      var overlay = seccion.querySelector('[data-nws-overlay-bg]');
      var cerrar = seccion.querySelector('[data-nws-cerrar]');
      var form = seccion.querySelector('.nws-form');
      var input = seccion.querySelector('.nws-input');
      var mensaje = seccion.querySelector('[data-nws-mensaje]');

      function abrir() {
        seccion.classList.add('nws-activo');
        seccion.setAttribute('aria-hidden', 'false');
        document.body.classList.add('nws-bloqueo');
        setTimeout(function () {
          if (input) input.focus();
        }, 250);
      }

      function cerrarOverlay() {
        seccion.classList.remove('nws-activo');
        seccion.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('nws-bloqueo');
      }

      if (overlay) overlay.addEventListener('click', cerrarOverlay);
      if (cerrar) cerrar.addEventListener('click', cerrarOverlay);

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && seccion.classList.contains('nws-activo')) {
          cerrarOverlay();
        }
      });

      function detectarClicInfo() {
        document.addEventListener('click', function (e) {
          var enlace = e.target.closest('a');
          if (!enlace) return;
          var texto = (enlace.textContent || '').trim().toLowerCase();
          if (texto === 'info') {
            e.preventDefault();
            e.stopPropagation();
            abrir();
          }
        }, true);
      }

      detectarClicInfo();

      if (mensaje && mensaje.classList.contains('nws-mensaje--ok')) {
        abrir();
      }
      if (mensaje && mensaje.classList.contains('nws-mensaje--error')) {
        abrir();
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', inicializar);
    } else {
      inicializar();
    }
    document.addEventListener('shopify:section:load', inicializar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["producto-becay"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function inicializar(seccion) {
      if (seccion.dataset.mpbInit) return;
      seccion.dataset.mpbInit = 'true';
      var form = seccion.querySelector('[data-mpb-form]');
      var variantInput = seccion.querySelector('[data-mpb-variant-id]');
      var tallaBtns = seccion.querySelectorAll('[data-mpb-talla]');
      var addBtn = seccion.querySelector('[data-mpb-add]');
      var addText = seccion.querySelector('[data-mpb-add-text]');
      var acordeon = seccion.querySelector('[data-mpb-acordeon-toggle]');
      tallaBtns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          if (btn.getAttribute('aria-disabled') === 'true') return;
          var variantId = btn.dataset.mpbVariant;
          if (variantInput) variantInput.value = variantId;
          tallaBtns.forEach(function (b) {
            b.classList.toggle('mpb-talla--activa', b === btn);
          });
          try {
            var url = new URL(window.location);
            url.searchParams.set('variant', variantId);
            window.history.replaceState({}, '', url);
          } catch (err) {}
        });
      });
      if (acordeon) {
        acordeon.addEventListener('click', function () {
          var abierto = acordeon.getAttribute('aria-expanded') === 'true';
          acordeon.setAttribute('aria-expanded', abierto ? 'false' : 'true');
        });
      }
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var formData = new FormData(form);
          var textoOriginal = addText ? addText.textContent : '';
          if (addBtn) addBtn.disabled = true;
          if (addText) addText.textContent = 'AÑADIENDO...';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: formData,
          })
            .then(function (r) { if (!r.ok) throw new Error('Error'); return r.json(); })
            .then(function () {
              if (addText) addText.textContent = '✓ AÑADIDO';
              document.dispatchEvent(new CustomEvent('cart:updated'));
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              setTimeout(function () {
                if (addBtn) addBtn.disabled = false;
                if (addText) addText.textContent = textoOriginal;
              }, 1500);
            })
            .catch(function () {
              if (addText) addText.textContent = 'ERROR';
              setTimeout(function () {
                if (addBtn) addBtn.disabled = false;
                if (addText) addText.textContent = textoOriginal;
              }, 1500);
            });
        });
      }
    }
    function init() {
      document.querySelectorAll('.mpb-seccion').forEach(inicializar);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["productos-six"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const ESDESKTOP = () => window.matchMedia('(min-width: 990px)').matches;

    class SpcSeccion {
      constructor(seccion) {
        this.seccion = seccion;
        this.tabs = seccion.querySelectorAll('[data-spc-tab]');
        this.panels = seccion.querySelectorAll('[data-spc-panel]');
        this.cards = seccion.querySelectorAll('[data-spc-card]');
        this.init();
      }

      init() {
        this.initTabs();
        this.initCards();
      }

      initTabs() {
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => {
            const target = tab.dataset.spcTab;
            this.tabs.forEach((t) => {
              const activo = t === tab;
              t.classList.toggle('spc-tab--activo', activo);
              t.setAttribute('aria-selected', activo ? 'true' : 'false');
            });
            this.panels.forEach((p) => {
              const activo = p.dataset.spcPanel === target;
              p.classList.toggle('spc-panel--activo', activo);
              if (activo) {
                p.removeAttribute('hidden');
              } else {
                p.setAttribute('hidden', '');
              }
            });
          });
        });
      }

      initCards() {
        this.cards.forEach((card) => this.initCard(card));
      }

      initCard(card) {
        const imagenes = card.querySelectorAll('[data-spc-image]');
        const dots = card.querySelectorAll('[data-spc-dot]');
        const prevBtn = card.querySelector('[data-spc-prev]');
        const nextBtn = card.querySelector('[data-spc-next]');
        const contenedor = card.querySelector('[data-spc-imagenes]');
        const link = card.querySelector('.spc-card-enlace');
        const total = imagenes.length;
        let index = 0;

        const mostrar = (nuevoIndex) => {
          if (!total) return;
          index = ((nuevoIndex % total) + total) % total;
          imagenes.forEach((img, i) => img.classList.toggle('spc-imagen--activa', i === index));
          dots.forEach((dot, i) => dot.classList.toggle('spc-dot--activo', i === index));
        };

        if (prevBtn) {
          prevBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            mostrar(index - 1);
          });
        }
        if (nextBtn) {
          nextBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            mostrar(index + 1);
          });
        }

        if (total > 1) {
          card.addEventListener('mouseenter', () => {
            if (ESDESKTOP()) mostrar(1);
          });
          card.addEventListener('mouseleave', () => {
            if (ESDESKTOP()) mostrar(0);
          });
        }

        if (total > 1 && contenedor && link) {
          this.vincularSwipe(contenedor, link, mostrar, () => index, total);
        }

        const botones = card.querySelectorAll('[data-spc-size]');
        botones.forEach((boton) => {
          boton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.agregarAlCarrito(boton);
          });
        });
      }

      vincularSwipe(contenedor, link, mostrar, obtenerIndex, total) {
        let startX = 0;
        let startY = 0;
        let currentX = 0;
        let arrastrando = false;
        let direccion = null;
        let movido = false;
        const umbral = 40;

        contenedor.addEventListener('touchstart', (e) => {
          if (ESDESKTOP()) return;
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          currentX = 0;
          arrastrando = true;
          direccion = null;
          movido = false;
        }, { passive: true });

        contenedor.addEventListener('touchmove', (e) => {
          if (!arrastrando || ESDESKTOP()) return;
          const deltaX = e.touches[0].clientX - startX;
          const deltaY = e.touches[0].clientY - startY;

          if (direccion === null) {
            if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 10) {
              direccion = 'horizontal';
            } else if (Math.abs(deltaY) > 10) {
              direccion = 'vertical';
            }
          }

          if (direccion === 'horizontal') {
            currentX = deltaX;
            movido = true;
          }
        }, { passive: true });

        contenedor.addEventListener('touchend', () => {
          if (!arrastrando || ESDESKTOP()) return;
          arrastrando = false;

          if (direccion === 'horizontal' && Math.abs(currentX) > umbral) {
            const idxActual = obtenerIndex();
            if (currentX < 0 && idxActual < total - 1) {
              mostrar(idxActual + 1);
            } else if (currentX > 0 && idxActual > 0) {
              mostrar(idxActual - 1);
            }
          }
        });

        link.addEventListener('click', (e) => {
          if (movido) {
            e.preventDefault();
            e.stopPropagation();
            movido = false;
          }
        });
      }

      agregarAlCarrito(boton) {
        const variantId = boton.dataset.spcSize;
        if (!variantId || boton.disabled) return;
        const textoOriginal = boton.textContent;
        boton.disabled = true;
        boton.classList.add('spc-talla--cargando');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
        })
          .then((r) => {
            if (!r.ok) throw new Error('Error');
            return r.json();
          })
          .then(() => {
            boton.textContent = '✓';
            boton.classList.remove('spc-talla--cargando');
            boton.classList.add('spc-talla--exito');
            document.dispatchEvent(new CustomEvent('cart:updated'));
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            setTimeout(() => {
              boton.textContent = textoOriginal;
              boton.classList.remove('spc-talla--exito');
              boton.disabled = false;
            }, 1400);
          })
          .catch(() => {
            boton.textContent = '!';
            boton.classList.remove('spc-talla--cargando');
            boton.classList.add('spc-talla--error');
            setTimeout(() => {
              boton.textContent = textoOriginal;
              boton.classList.remove('spc-talla--error');
              boton.disabled = false;
            }, 1400);
          });
      }
    }

    function inicializar() {
      document.querySelectorAll('.spc-seccion').forEach((seccion) => {
        if (!seccion.dataset.spcInit) {
          new SpcSeccion(seccion);
          seccion.dataset.spcInit = 'true';
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', inicializar);
    } else {
      inicializar();
    }

    document.addEventListener('shopify:section:load', inicializar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["selector-region"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class SrgDropdown {
      constructor(dropdown) {
        this.dropdown = dropdown;
        this.tipo = dropdown.dataset.srgDropdown;
        this.trigger = dropdown.querySelector('[data-srg-trigger]');
        this.panel = dropdown.querySelector('[data-srg-panel]');
        this.valor = dropdown.querySelector('[data-srg-valor]');
        this.buscador = dropdown.querySelector('[data-srg-buscador]');
        this.lista = dropdown.querySelector('[data-srg-lista]');
        this.opciones = Array.from(dropdown.querySelectorAll('[data-srg-opcion]'));
        this.vacio = dropdown.querySelector('[data-srg-vacio]');
        this.seleccionado = this.obtenerSeleccionado();
        this.init();
      }

      obtenerSeleccionado() {
        const seleccionada = this.opciones.find((o) => o.classList.contains('srg-dropdown-opcion--seleccionada'));
        if (!seleccionada) return null;
        return {
          iso: seleccionada.dataset.srgValorIso,
          nombre: seleccionada.dataset.srgValorNombre
        };
      }

      init() {
        if (this.trigger) {
          this.trigger.addEventListener('click', (e) => {
            e.stopPropagation();
            this.toggle();
          });
        }

        this.opciones.forEach((opcion) => {
          opcion.addEventListener('click', (e) => {
            e.stopPropagation();
            this.seleccionar(opcion);
          });
        });

        if (this.buscador) {
          this.buscador.addEventListener('input', (e) => this.filtrar(e.target.value));
          this.buscador.addEventListener('click', (e) => e.stopPropagation());
        }
      }

      toggle() {
        if (this.dropdown.classList.contains('srg-abierto-dropdown')) {
          this.cerrar();
        } else {
          this.abrir();
        }
      }

      abrir() {
        document.querySelectorAll('.srg-dropdown.srg-abierto-dropdown').forEach((d) => {
          if (d !== this.dropdown) d.classList.remove('srg-abierto-dropdown');
        });
        this.dropdown.classList.add('srg-abierto-dropdown');
        if (this.trigger) this.trigger.setAttribute('aria-expanded', 'true');
        setTimeout(() => {
          if (this.buscador) this.buscador.focus();
        }, 100);
      }

      cerrar() {
        this.dropdown.classList.remove('srg-abierto-dropdown');
        if (this.trigger) this.trigger.setAttribute('aria-expanded', 'false');
        if (this.buscador) this.buscador.value = '';
        this.filtrar('');
      }

      seleccionar(opcion) {
        this.opciones.forEach((o) => {
          o.classList.remove('srg-dropdown-opcion--seleccionada');
          o.setAttribute('aria-selected', 'false');
        });
        opcion.classList.add('srg-dropdown-opcion--seleccionada');
        opcion.setAttribute('aria-selected', 'true');
        this.seleccionado = {
          iso: opcion.dataset.srgValorIso,
          nombre: opcion.dataset.srgValorNombre
        };
        if (this.valor) this.valor.textContent = this.seleccionado.nombre;
        this.cerrar();
      }

      filtrar(texto) {
        const consulta = texto.trim().toLowerCase();
        let visibles = 0;
        this.opciones.forEach((opcion) => {
          const buscable = opcion.dataset.srgBuscable || '';
          const coincide = consulta === '' || buscable.includes(consulta);
          opcion.hidden = !coincide;
          if (coincide) visibles += 1;
        });
        if (this.vacio) this.vacio.hidden = visibles > 0;
      }

      obtenerValor() {
        return this.seleccionado ? this.seleccionado.iso : null;
      }
    }

    class SrgSelector {
      constructor(seccion) {
        this.seccion = seccion;
        this.modal = seccion.querySelector('[data-srg-modal]');
        this.overlay = seccion.querySelector('[data-srg-overlay]');
        this.confirmarBtn = seccion.querySelector('[data-srg-confirmar]');
        this.dropdowns = {};
        seccion.querySelectorAll('[data-srg-dropdown]').forEach((d) => {
          this.dropdowns[d.dataset.srgDropdown] = new SrgDropdown(d);
        });
        this.init();
      }

      init() {
        document.addEventListener('click', (e) => {
          const trigger = e.target.closest('.hfh-icono[aria-label="Idioma y país"]');
          if (trigger) {
            e.preventDefault();
            this.abrir();
            return;
          }
          Object.values(this.dropdowns).forEach((d) => {
            if (d.dropdown.classList.contains('srg-abierto-dropdown') && !d.dropdown.contains(e.target)) {
              d.cerrar();
            }
          });
        });

        if (this.overlay) {
          this.overlay.addEventListener('click', () => this.cerrar());
        }

        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.seccion.classList.contains('srg-abierto')) {
            const algunDropdown = Object.values(this.dropdowns).some((d) => d.dropdown.classList.contains('srg-abierto-dropdown'));
            if (algunDropdown) {
              Object.values(this.dropdowns).forEach((d) => d.cerrar());
            } else {
              this.cerrar();
            }
          }
        });

        if (this.confirmarBtn) {
          this.confirmarBtn.addEventListener('click', () => this.confirmar());
        }
      }

      abrir() {
        this.seccion.classList.add('srg-abierto');
        this.seccion.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }

      cerrar() {
        Object.values(this.dropdowns).forEach((d) => d.cerrar());
        this.seccion.classList.remove('srg-abierto');
        this.seccion.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }

      confirmar() {
        const countryCode = this.dropdowns.country ? this.dropdowns.country.obtenerValor() : null;
        const localeCode = this.dropdowns.language ? this.dropdowns.language.obtenerValor() : null;
        const returnTo = window.location.pathname + window.location.search;

        const fetches = [];

        if (countryCode) {
          const fdCountry = new FormData();
          fdCountry.append('_method', 'put');
          fdCountry.append('form_type', 'localization');
          fdCountry.append('country_code', countryCode);
          fdCountry.append('return_to', returnTo);
          fetches.push(
            fetch(window.Shopify.routes.root + 'localization', {
              method: 'POST',
              body: fdCountry,
              headers: { Accept: 'text/html' }
            })
          );
        }

        if (localeCode) {
          const fdLang = new FormData();
          fdLang.append('_method', 'put');
          fdLang.append('form_type', 'localization');
          fdLang.append('locale_code', localeCode);
          fdLang.append('return_to', returnTo);
          fetches.push(
            fetch(window.Shopify.routes.root + 'localization', {
              method: 'POST',
              body: fdLang,
              headers: { Accept: 'text/html' }
            })
          );
        }

        if (fetches.length === 0) {
          this.cerrar();
          return;
        }

        Promise.all(fetches)
          .then(() => {
            window.location.reload();
          })
          .catch(() => {
            window.location.reload();
          });
      }
    }

    function inicializar() {
      document.querySelectorAll('[data-srg-seccion]').forEach((seccion) => {
        if (!seccion.dataset.srgInit) {
          new SrgSelector(seccion);
          seccion.dataset.srgInit = 'true';
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', inicializar);
    } else {
      inicializar();
    }

    document.addEventListener('shopify:section:load', inicializar);
  })();

  } catch(e) { console.error(e); }
})();
})();
